import { createStore } from "vuex"
import user from './modules/user'

// 定义State类型
export interface State {
    [key: string]: any
  }

  
// 创建store实例
const store = createStore<State>({
    state: {},
    mutations: {},
    actions: {},
    getters: {},
    modules: {
        user
    }
})

export default store
